import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import ResortExperience from './components/ResortExperience';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import Gallery from './pages/Gallery';
import GallerySection from './components/GallerySection';
import EventPage from './pages/EventPage';

function App() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "918340539463";
    const message = "Hi, how can we help you?";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };
  return (
    <Router>
      <Navbar />
  
      {/* <div className="sticky-book-now">
        <a href="#booking">BOOK NOW</a>
      </div> */}

<button
        onClick={handleWhatsAppClick}
        className="whatsapp-button"
        style={{ border: 'none', background: 'none', cursor: 'pointer' }}
      >
        <img src="https://custpostimages.s3.ap-south-1.amazonaws.com/sb_images/whatsapp_latest.svg" />
      </button>

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Home />
              <ResortExperience />
              <GallerySection></GallerySection>
              <Testimonials />
              <Footer />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <About />
              <Footer />
            </>
          }
        />
        <Route
          path="/contact"
          element={
            <>
              <ContactUs />
              <Footer />
            </>
          }
        />

        <Route
          path="/gallery"
          element={
            <>
              <Gallery />
              <Footer />
            </>
          }
        />


<Route
          path="/events"
          element={
            <>
              <EventPage />
              <Footer />
            </>
          }
        />

      </Routes>
 
    </Router>
  );
}

export default App;
